<template>
  <div class="verval">
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <h1 class="headline info--text"> <strong>Kelola Peserta</strong> Pelatihan Pengimbasan </h1>
            <div>
              Modul ini digunakan untuk melakukan Kelola Daftar Peserta Pelatihan Pengimbasan Sekolah Penggerak
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card flat>
      <v-card-title class="pa-0">
        <base-table-header
          outlined-button
          @download="onDownloadList"
          @filter="onFilter"
          @search="onSearch"
          @reload="onReload"
        >
          <template v-slot:toolbar>
            <v-select
              class="mt-7"
              v-model="params.gelombang"
              :items="mGelombang"
              item-text="text"
              item-value="value"
              dense
              outlined
              @change="fetchData"
              style="max-width: 180px"
            />
          </template>
          <template v-slot:subtitle>
            <div class="body-1 black--text"> Daftar Peserta </div>
          </template>
        </base-table-header>
      </v-card-title>
      <v-divider />
      <base-list-filter
        ref="filter"
        title="Pilih Filter Status"
        :filtered="filtered"
        :filters="formFilter"
        :paramsFilter="filters"
        @save="filterSave"
      />
      <v-card-text class="pa-0">
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list>
                <v-list-item class="px-0">
                  <v-list-item-avatar color="secondary">
                    <v-icon dark>mdi-home</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-row>
                      <v-col cols="12" md="5">
                        <div class="text-body-1 font-weight-medium">{{ $getDeepObj(item, 'sekolah.nama') }}</div>
                        <div class="caption">
                          <span class="grey--text text--darken-1">NPSN:</span>
                          {{ $getDeepObj(item, 'sekolah.npsn') || '-' }}
                        </div>
                        <div class="caption">
                          <span class="grey--text text--darken-1">Jenjang:</span>
                          {{ $getDeepObj(item, 'sekolah.m_jenjang.singkat') || '-' }}
                        </div>
                      </v-col>
                      <v-col cols="12" md="4">
                        <div><span class="caption">Status</span></div>
                        <div>
                          <v-chip small :color="M_COLOR[item.k_verval_psp] || 'grey'" dark>
                            {{ $getDeepObj(item, 'm_verval_psp.keterangan') || '-' }}
                          </v-chip>
                        </div>
                        <div v-if="item.wkt_ajuan" class="caption mt-1">
                          <span class="grey--text text--darken-1">Oleh:</span>
                          {{ getInfoAkunAjuan(item) }}
                        </div>
                        <div v-if="item.wkt_ajuan" class="caption">
                          <span class="grey--text text--darken-1">Tanggal:</span>
                          {{ $localDate(item.wkt_ajuan, false, true) }} WIB
                        </div>
                      </v-col>
                      <v-col cols="12" md="2">
                        <div><span class="caption">Aksi Selanjutnya</span></div>
                        <div>
                          <v-btn v-if="+item.k_verval_psp < 2" color="primary" small block @click="onUbahPeserta(item)">
                            Tambah Peserta
                          </v-btn>
                          <v-btn v-else color="success" outlined dark small block @click="onDetail(item)">
                            LIHAT DETIL
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                  <v-list-item-action-text>
                    <template v-if="allows(item)">
                      <base-list-action :data="item" :actions="actions" :allow="allow" @action="onAction" />
                    </template>
                    <template v-else>
                      <div style="min-width: 40px">&nbsp;</div>
                    </template>
                  </v-list-item-action-text>
                </v-list-item>
              </v-list>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" :allow="!allow" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
    <base-modal-full
      ref="modal"
      :title="`${formulir.mode === 'form' ? 'Formulir' : 'Detail'} Peserta Pelatihan Pengimbasan`"
      :use-save="formulir.mode === 'form'"
      @save="onSave"
    >
      <form-ajuan
        ref="formulir"
        :ajuan="formulir.ajuan || {}"
        :kandidats="formulir.kandidats || []"
        :pesertas="formulir.pesertas || []"
        :is-preview="formulir.mode === 'detail'"
      />
    </base-modal-full>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import actions from './actions';
import list from '@mixins/list';
import FormAjuan from '@views/gtk/pengimbasan/Formulir.vue';
export default {
  name: 'Index',
  components: { FormAjuan },
  mixins: [list],
  data() {
    return {
      actions: actions,
      M_COLOR: {
        1: 'grey',
        2: 'blue',
        4: 'success',
        5: 'warning',
      },
      formulir: {},
      listLaporan: [
        {
          key: 'download',
          label: `Daftar Laporan Ajuan Peserta Pelatihan`,
        },
      ],
    };
  },
  computed: {
    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),

    mGelombang() {
      return [{ text: 'Gelombang 1', value: 1 }];
    },

    formFilter() {
      let jenjangs = Object.assign({}, this.masters.jenjang);

      for (const kJenjang in jenjangs) {
        if (+kJenjang > 6) {
          delete jenjangs[kJenjang];
        }

        if (/paud/.test(this.type) && +kJenjang !== 1) {
          delete jenjangs[kJenjang];
        }
      }

      return [
        {
          label: 'Pilih Status Verval',
          row: true,
          default: true,
          type: 'checkbox',
          model: 'k_verval_psp',
          master: this.$mapForMaster(this.mas),
          props: ['attach', 'chips', 'deletable-chips', 'multiple', 'small-chips'],
          grid: { cols: 12 },
        },
        {
          label: 'Pilih Jenjang',
          type: 'select',
          default: true,
          model: 'k_jenjang',
          master: this.$mapForMaster(jenjangs),
          props: ['multiple', 'chips', 'small-chips'],
          grid: { cols: 12, md: 6 },
        },
      ];
    },

    filtersMaster() {
      return {
        k_verval_psp: this.masters && this.masters['verval_psp'],
        k_jenjang: this.masters && this.masters['jenjang'],
      };
    },
  },
  created() {
    this.params.gelombang = 1;
    this.getMasters('verval_psp;jenjang|value:singkat');
  },
  methods: {
    ...mapActions('master', ['getMasters']),
    ...mapActions('pengimbasan', ['fetch', 'candidate', 'peserta', 'save', 'reset']),

    allows(data) {
      return (
        this.actions.filter((action) => {
          return this.allow(action, data);
        }).length > 0
      );
    },

    getInfoAkunAjuan(item) {
      if (this.$isObject(item.akun || {})) {
        return `${item.akun.nama} (Admin BGP/BBGP)`;
      }

      return `${item.ptk && item.ptk.nama} (KS)`;
    },

    async onUbahPeserta(item) {
      const kandidats = await this.candidate({ id: item.psp_pelatihan_ajuan_id });
      const ajuan = await this.peserta({ id: item.psp_pelatihan_ajuan_id });
      const pesertas = ajuan.psp_pelatihan_kandidats || [];
      const pesertasGuru = pesertas
        .filter((peserta) => peserta.ptk_id !== ajuan.ptk_id)
        .map((peserta) => peserta.ptk_id);
      const kandidatsGuru = kandidats.filter((kandidat) => kandidat.ptk_id !== ajuan.ptk_id);

      this.$set(this.formulir, 'mode', 'form');
      this.$set(this.formulir, 'id', item.psp_pelatihan_ajuan_id);
      this.$set(this.formulir, 'ajuan', ajuan);
      this.$set(this.formulir, 'kandidats', kandidatsGuru);
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset(pesertasGuru);
      });
    },

    onHapusPeserta(item) {
      this.$confirm(
        `Apakah Anda yakin ingin menghapus data peserta pelatihan dari sekolah <strong>${this.$getDeepObj(
          item,
          'sekolah.nama'
        )}</strong>?`,
        'Konfirmasi',
        { tipe: 'warning' }
      ).then(() => {
        this.$refs.modal.loading = true;
        this.reset({ id: item.psp_pelatihan_ajuan_id }).then(() => {
          this.$success('Data peserta berhasil dihapus');
          this.onReload();
        });
      });
    },

    async onDetail(item) {
      const ajuan = await this.peserta({ id: item.psp_pelatihan_ajuan_id });
      const pesertas = ajuan.psp_pelatihan_kandidats || [];

      this.$set(this.formulir, 'mode', 'detail');
      this.$set(this.formulir, 'id', item.psp_pelatihan_ajuan_id);
      this.$set(this.formulir, 'ajuan', ajuan);
      this.$set(this.formulir, 'pesertas', pesertas);
      this.$refs.modal.open();
    },

    onSave() {
      const values = this.$refs.formulir.getValue();

      if (!values.length) {
        this.$error('Silahkan pilih peserta pelatihan terlebih dahulu');
        this.$refs.modal.loading = false;
        return;
      }

      this.save({ id: this.formulir.id, params: { kandidat: values } })
        .then(() => {
          this.$success('Berhasil disimpan');
          this.$refs.modal.dialog = false;
          this.onReload();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
